//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { linkedObjectToSelectOption } from "@/utils/searchObjectsAndArticles.js";

export default {
  name: "LinkedObjectPublic",
  props: {
    value: {
      type: [Object, String, Number],
      default: null,
    },
  },
  computed: {
    linked() {
      return linkedObjectToSelectOption(this.value)
    },
    linkTo() {
      const slug = this.linked.slug || this.linked.url || this.linked.id

      if (this.linked.type === 'art') {
        return {
          name: this.linked.is_spec_project ? 'sp-slug' : 'art-slug',
          params: { slug },
        }
      }

      return {
        name: 'objects-slug',
        params: { slug },
      }
    },
  },
}
